import React from 'react';

const Footer = () => (
  <div className="mt-24" />
);

export default Footer;
